import React from 'react'
import { useParams } from 'react-router-dom'
import Form from './Form'
import { MapFormProvider } from './FormContext'
import { useGetMap, useUpdateMap } from '../../hooks/api/map'
import NotFound from '../../pages/NotFound'

export const EditMap = () => {
  const { id } = useParams()

  const { data, isLoading } = useGetMap(id)

  if (isLoading) return null

  if (!data) return <NotFound />

  return (
    <MapFormProvider>
      <Form api={useUpdateMap} defaultValues={data} />
    </MapFormProvider>
  )
}
